import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export type UaProvisioningStatus = 'NOT_STARTED' | 'CREATING' | 'ACTIVE' | 'FAILED';

export interface UaAccountRecord {
  id: string;
  classId: string;
  participantId: string;
  participantEmail: string;
  participantDisplayName: string;
  status: UaProvisioningStatus;
  userPrincipalName?: string;
  temporaryAccessPass?: string;
  errorMessage?: string;
  provisionedAt?: string;
  /** Azure subscription ID pre-assigned to this participant at class-confirmation time. */
  subscriptionId?: string;
}

export interface UaProvisioningStatusSummary {
  total: number;
  notStarted: number;
  creating: number;
  active: number;
  failed: number;
  isComplete: boolean;
  hasFailures: boolean;
}

@Injectable({ providedIn: 'root' })
export class ClassUserAccountService {
  constructor(private http: HttpClient) { }

  getAll(classId: string): Observable<UaAccountRecord[]> {
    return this.http.get<UaAccountRecord[]>(`/api/v1/classes/${classId}/ua-subscriptions`);
  }

  getStatus(classId: string): Observable<UaProvisioningStatusSummary> {
    return this.http.get<UaProvisioningStatusSummary>(`/api/v1/classes/${classId}/ua-subscriptions/status`);
  }

  provision(classId: string): Observable<{ message: string; warnings: string[]; statusUrl: string }> {
    return this.http.post<{ message: string; warnings: string[]; statusUrl: string }>(
      `/api/v1/classes/${classId}/ua-subscriptions/provision`,
      {}
    );
  }

  retryFailed(classId: string): Observable<void> {
    return this.http.post<void>(`/api/v1/classes/${classId}/ua-subscriptions/retry-failed`, {});
  }
}
